import { createContext } from 'react'
import type { Messages } from './messages'
import { SOURCE_LANGUAGE, type LanguageId } from './types'
import { ko } from './messages/ko'

export interface LanguageValue {
  languageId: LanguageId
  messages: Messages
  /**
   * 사용자가 고른 값. 고른 적이 없으면 없다.
   *
   * 지금 화면이 선 언어와 다르다. 고른 적이 없는 사람의 화면도 어떤 언어로든 서 있고 그 값은
   * 협상 결과다. 목록의 선택 표시가 가리키는 것은 이쪽이다.
   */
  chosenLanguage: LanguageId | null
  /**
   * 사용자가 목록에서 하나를 고른 것. 이번 방문의 선택이 되고 계정에도 올라간다.
   *
   * 시스템 설정을 고르면 없음이 온다. 언어를 고르는 것이 아니라 고른 값을 비우는 일이라
   * 계정에 남은 값과 이 브라우저에 남은 명시 선택을 함께 지운다.
   */
  chooseLanguage: (next: LanguageId | null) => void
  /** 계정에 남기지 못했는지. 화면은 고른 언어 그대로 두고 이 표시만 안내 한 줄이 읽는다. */
  saveFailed: boolean
}

export const LanguageContext = createContext<LanguageValue | null>(null)

/** Provider 밖에서 읽는 일이 없어야 하지만 타입을 위해 기본값을 둔다. */
export const FALLBACK_LANGUAGE_VALUE: LanguageValue = {
  languageId: SOURCE_LANGUAGE,
  messages: ko,
  chosenLanguage: null,
  chooseLanguage: () => {},
  saveFailed: false,
}
